import { http } from './http'

const isTrackingActive = () => {
  return Boolean(window?.utag?.view)
}

/**
 * Get tracking data
 */
export const getTrackingData = async (view, id, query) => {
  if (!isTrackingActive()) {
    return {}
  }

  try {
    const response = await http.get(
      `/tracking/pageview/${view}${id ? '/' + id : ''}${query ? '?' + query : ''}`,
      { cache: false },
    )

    return response.data || {}
  } catch (error) {
    const errorLog = `Error fetching tracking data for ${view}${id ? ` with id ${id}` : ''}:`
    console.warn(errorLog, error)
    return {}
  }
}

/**
 * Get internal tracking data
 */
export const getInternalTrackingData = async (event, id, option) => {
  if (!isTrackingActive()) {
    return {}
  }

  try {
    const response = await http.get(
      `/tracking/internal/${event}${id ? '/' + id : ''}${option ? '?option=' + option : ''}`,
      { cache: false },
    )

    return response.data || {}
  } catch (error) {
    const errorLog = `Error fetching internal tracking data for ${event}${id ? ` with id ${id}` : ''}:`
    if (!error.name || error.name !== 'CanceledError') {
      console.error(errorLog, error)
      throw error
    }

    console.warn(errorLog, error)
    return {}
  }
}
